import { MetaReducer } from '@ngrx/store';
import { localStorageSyncReducer } from './local-storage-sync.meta-reducers';

export const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];
